import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './interest-rates.component.scss';
import axios from 'axios';
var InterestRates = /** @class */ (function (_super) {
    tslib_1.__extends(InterestRates, _super);
    function InterestRates(element) {
        return _super.call(this, element) || this;
    }
    InterestRates.prototype.init = function () {
        if (this.element.querySelector('.js-standard-bank-share-price__title')) {
            this.containerApiTitle = this.element.querySelector('.js-standard-bank-share-price__title');
            this.containerApiArrow = this.element.querySelector('.js-standard-bank-share-price__arrow');
            this.containerApiValue = this.element.querySelector('.js-standard-bank-share-price__value');
            this.containerApiTimeStamp = this.element.querySelector('.js-standard-bank-share-price__timestamp');
            this.apiSharePrice();
        }
    };
    InterestRates.prototype.bindEvents = function () {
    };
    InterestRates.prototype.apiSharePrice = function () {
        var _this = this;
        var randomNumber = Math.floor(Math.random() * 100000) + 1;
        var url = "/services/sbsasharepricetimedate.jsp?v=" + randomNumber;
        // let url = "/file_source/Market-Data-Files/TRKD/Shares.JSON";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        axios.get(url).then(function (response) {
            _this.apiJson = response.data;
            // this.containerApiTitle.innerHTML = this.apiJson[3].CF_NAME;
            _this.containerApiTitle.innerHTML = 'Standard Bank Share Price';
            _this.containerApiValue.innerHTML = _this.apiJson[3].offer;
            _this.containerApiTimeStamp.innerHTML = '';
            if (_this.apiJson[0].CF_NETCHNG < 0) {
                // this.containerApiArrow.innerHTML = `
                // <i data-component="icon" data-icon="icon-arrow-down-red" data-gradient="" data-path="/file_source/assets/icons/" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28">
                // 	<path fill="#D0021B" fill-rule="nonzero" d="M.5 16.35l1.627-1.65 8.714 8.834V0h2.302v23.534l8.73-8.85 1.627 1.65L11.992 28 .5 16.35"></path>
                // </svg></i>`;
            }
            else {
                // this.containerApiArrow.innerHTML = `
                // <i data-component="icon" data-icon="icon-arrow-up-green" data-gradient="" data-path="/file_source/assets/icons/" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28">
                // 	<path fill="#00AD6C" fill-rule="nonzero" d="M.5 11.65l1.627 1.65 8.714-8.834V28h2.302V4.466l8.73 8.85 1.627-1.65L11.992 0 .5 11.65"></path>
                // </svg></i>`;
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    return InterestRates;
}(Base));
export { InterestRates };



//////////////////
// WEBPACK FOOTER
// ./components/interest-rates/interest-rates.component.ts
// module id = 393
// module chunks = 0